import {RemoteGetLifeplaceProducts} from 'data/usecases/private/lifeplace/remote-get-lifeplace-products';
import {GetLifeplaceProducts} from 'domain/usecases/private/lifeplace/get-lifeplace-products';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {LifeplaceEndpoints} from '../../endpoints';

export const makeGetLifeplaceProducts = (): GetLifeplaceProducts =>
	new RemoteGetLifeplaceProducts(
		makeBFFApiUrl(LifeplaceEndpoints.lifePlaceProducts),
		makeAuthorizeHttpClientDecorator(),
	);
